export const SHORTCUTS: Array<[string, string]> = [
  ['double-tap / Alt-click', 'latch an eternal drone'],
  ['Shift-click', 'hold a voice'],
  ['Esc', 'release everything'],
  ['← →', 'tonic by fifths (Shift: semitones)'],
  ['↑ ↓ · 1–0', 'scale'],
  ['Space', 'Play / Continuous'],
  ['wheel · Ctrl-wheel', 'brightness · width'],
  ['fire ring', 'tap = tonic · circle = prayer wheel'],
];

export function ShortcutsHint() {
  return (
    <div className="glass glass--pill chrome-bl shortcuts" aria-label="Keyboard shortcuts">
      <span><kbd>dbl-tap</kbd> latch</span>
      <span><kbd>⇧</kbd> hold</span>
      <span><kbd>Esc</kbd> clear</span>
      <span><kbd>←</kbd><kbd>→</kbd> tonic</span>
      <span><kbd>↑</kbd><kbd>↓</kbd> scale</span>
      <span><kbd>␣</kbd> mode</span>
    </div>
  );
}
